import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, switchMap, catchError } from 'rxjs';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  private lastRefreshTime = 0; // timestamp en segundos
  private cooldownSeconds = environment.refreshCooldownSeconds;

  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();

    if (!token) {
      return next.handle(req);
    }

    // Si el token aún no expira, y no hemos hecho un refresh recientemente:
    if (this.isTokenValid(token) && this.shouldRefresh()) {
      this.lastRefreshTime = Math.floor(Date.now() / 1000);
      this.authService.refreshToken().subscribe(); // async, no bloqueamos la solicitud
    }

    const tokenReq = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + token
      }
    });

    return next.handle(tokenReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 498) {
          this.authService.logOutUser();
          this.router.navigate(['/auth/login']);
        }
        return throwError(() => error);
      })
    );
  }

  private isTokenValid(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp;
      const now = Math.floor(Date.now() / 1000);
      return exp > now;
    } catch {
      return false;
    }
  }

  private shouldRefresh(): boolean {
    const now = Math.floor(Date.now() / 1000);
    return now - this.lastRefreshTime > this.cooldownSeconds;
  }
}
